<template>
    <component
        :is="href ? 'a' : 'div'"
        :href="href || undefined"
        :target="href ? '_blank' : undefined"
        :rel="href ? 'noopener noreferrer' : undefined"
        class="trusted-company-badge"
        :class="{ 'trusted-company-badge--link': href }"
    >
        <img
            :src="`${$baseUrl}mekon_trusted_logo.png`"
            :alt="$t('landingPage.trustedCompanyBadge')"
            width="50"
            height="50"
            class="trusted-company-badge__img"
        />
        <div class="trusted-company-badge__label">
            {{ ($t("landingPage.trustedCompanyBadge") || "").toUpperCase() }}
        </div>
    </component>
</template>

<script>
export default {
    name: "TrustedCompanyBadge",
    props: {
        /** When set, badge opens this URL in a new tab (company profile on firmadeincredere.ro). */
        href: { type: String, default: "" },
    },
};
</script>

<style scoped>
.trusted-company-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    max-width: 140px;
    text-decoration: none;
    color: inherit;
}
.trusted-company-badge--link {
    cursor: pointer;
}
.trusted-company-badge__img {
    object-fit: contain;
}
.trusted-company-badge__label {
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.2;
}
</style>
